import { render, staticRenderFns } from "./pod_proof.vue?vue&type=template&id=4a870c12&"
import script from "./pod_proof.vue?vue&type=script&lang=js&"
export * from "./pod_proof.vue?vue&type=script&lang=js&"
import style0 from "./pod_proof.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports